<template>
  <div class="group-rounded-box my-3 mx-4">
    <span class="title">
      Delivery
      <input type="checkbox" v-model="isDeliveredIn" @change="$emit('updateDeliveryStatus', isDeliveredIn)" />
    </span>
    <el-form ref="deliveredInData" :model="deliveredInData" :rules="formRules" label-position="top">
      <el-row type="flex" justify="space-around" v-if="isDeliveredIn">
        <el-col :span="7">
          <el-form-item
            label="Haulage PPL"
            prop="haulageRate"
          >
            <el-input
              v-model="deliveredInData.haulageRate"
              :disabled="!isDeliveredIn"
              v-cleave="numeralPositive"
              @change="$emit('updateDeliveredInData', formattedDeliveredInData)"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item
            label="Delivery Location"
            prop="selectedDeliveryLocation"
          >
            <el-select
              v-model="deliveredInData.selectedDeliveryLocation"
              value-key="_id"
              placeholder="Search delivery location"
              filterable
              @change="$emit('updateDeliveredInData', formattedDeliveredInData)"
              :disabled="!isDeliveredIn"
            >
              <el-option
                v-for="location in deliveryLocations"
                :key="location._id"
                :label="location.name"
                :value="location"
              >
              </el-option>
              <template #empty>No location found</template>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item
            label="Delivery Date"
            prop="deliveryDate"
          >
            <el-date-picker
              class="w-100"
              v-model="deliveredInData.deliveryDate"
              @change="$emit('updateDeliveredInData', formattedDeliveredInData)"
              type="date"
              :picker-options="pickerOptions"
              :disabled="!isDeliveredIn"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>


<script>
import { getLocations } from "@/api/metadata";
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  data() {
      const haulageValidator = (rule, value, callback) => {
      if (Number(value) <= 0) {
        callback(new Error());
      } else {
        callback();
      }
    }
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < moment().startOf("day");
        },
      },
      formRules: {
        selectedDeliveryLocation: [{ required: true, message: "Delivery location is required", trigger: ["change", "blur"] }],
        haulageRate: [{ required: true, validator: haulageValidator, message: "Haulage rate must be greater than 0", trigger: ["change", "blur"] }],
      },
      isDeliveredIn: false,
      deliveredInData: {
        haulageRate: 0,
        selectedDeliveryLocation: null,
        deliveryDate: null,
      }
    };
  },
  props: {
    customer: {
      type: Object,
      required: true,
    },
    haulageError: {
      type: Boolean,
      required: false,
    },
    initialDeliveredInData: {
      type: Object
    }
  },
  created: async function () {
    this.deliveryLocations = await this.getDeliveryLocations(this.customer.id);
    if (this.initialDeliveredInData) {
      const {haulageRate, deliveryDate, location_id, isDeliveredIn} = this.initialDeliveredInData;
      this.isDeliveredIn = isDeliveredIn;
      this.deliveredInData.haulageRate = haulageRate ?? 0;
      this.deliveredInData.deliveryDate = deliveryDate;
      this.deliveredInData.selectedDeliveryLocation = this.deliveryLocations.find(location => location._id === location_id);
    }
  },
  computed: {
    ...mapGetters("inputCheckers", ["numeralPositive"]),
    formattedDeliveredInData() {
      return {
        deliveryDate: this.deliveredInData.deliveryDate === "" ? undefined : this.deliveredInData.deliveryDate,
        haulageRate: Number(this.deliveredInData.haulageRate),
        location_id: this.deliveredInData.selectedDeliveryLocation ? this.deliveredInData.selectedDeliveryLocation._id : undefined
      }
    }
  },
  methods: {
    getDeliveryLocations: async function (buyerAccountId) {
      const { data } = await getLocations(buyerAccountId);
      return data.locations;
    },
    validate: function(cb) {
      this.$refs.deliveredInData.validate((valid) => {
        cb(valid);
      })
    }
  },
};
</script>
<style lang="scss" scoped>
.el-row {
  margin: 20px;
}
</style>
